/**
 * /dev/vlist 的懒加载壳：demo 本体（VirtualList + 10k 数据生成）动态 import，
 * 保持首屏 bundle 零增量（体积预算口径）。外壳只 import 本文件。
 */
import { useEffect, useState } from 'preact/hooks';
import type { FunctionComponent } from 'preact';

export function VlistDemoLazy() {
  const [Page, setPage] = useState<FunctionComponent | null>(null);
  useEffect(() => {
    let cancelled = false;
    void import('./VlistDemoPage').then((m) => {
      if (!cancelled) setPage(() => m.VlistDemoPage);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  if (Page === null) return <div data-testid="vlist-demo-loading">加载中…</div>;
  return <Page />;
}
